import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useEffect, useState } from "react";
import { API_URL, baseurl } from "../../_config";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

const DonationDetail = () => {
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [donationDetail, setDonationDetail] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchdonationDetail = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getDonationDetail}`);
            if (response.status === 200) {
                setDonationDetail(response?.data?.data)
            }
        } catch (error) {
            setError("Error fetching menu data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchdonationDetail();
    }, []);

    const onDonationDetailByLoginId = (row) => {
        navigate(`/donation-detail/${row?.LoginId}`);
    }


    useEffect(() => {
        if (searchTerm) {
            const filtered = donationDetail.filter(item =>
                item.Name.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.PAN.toString().toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(donationDetail);
        }
    }, [searchTerm, donationDetail]);

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Name',
            selector: row => row.Name,
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Email',
            selector: row => (
                <div className="booking_data curser-pointer" onClick={() => onDonationDetailByLoginId(row)}>
                    <h6>{row?.Email}</h6>
                </div>
            ),
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'PAN',
            selector: row => row.PAN,
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Address',
            selector: row => row.Address,
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'Amount',
            selector: row => row.Amount,
            sortable: true,
            minWidth: '100px'
        },
        {
            name: 'Created Date',
            selector: row => {
                if (row.CreatedDate) {
                    const date = new Date(row.CreatedDate);

                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0');
                    const year = indianTime.getFullYear();

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: false,
            minWidth: '180px'
        },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Donation</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                {error ? (
                    <p>Data not avaiable</p>
                ) : (
                    <div className="datatable mt-4">
                        <DataTable
                            columns={columns}
                            data={filteredData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    </div>
                )}
            </div>
        </Layout>
    )
}

export default DonationDetail;